import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_ENDPOINTS } from "../../../../util/constants";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import { actions } from "../../../Dashboard/_redux/dashboardRedux";
import { DEAFAULT_PAGESIZE } from "../../pages/Configuration/Sounds";

const initialListingsState = {
  activeSoundTab: 0,
  selectedSounds: [],
  soundList: [],
  soundListMetaData: {},
  searchQuery: null,
  pageSize: DEAFAULT_PAGESIZE,
  currentPage: 1,
  soundListingsPayload: null
};

export const fetchTTSSoundsLists = createAsyncThunk(
  "soundSlice/fetchTTSSoundsLists",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getTtsSounds, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "sound_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "sound_lists",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const updateUserSound = createAsyncThunk(
  "soundSlice/updateUserSound",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(
        API_ENDPOINTS.getTtsSounds + params.id,
        params
      );
      dispatch(
        actions.setLoadingState({
          resource: "upload_sound",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      const {
        response: {
          data: { error_message },
        },
      } = error;

      dispatch(
        actions.setLoadingState({
          resource: "upload_sound",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error_message });
    }
  }
);

export const fetchTextToSpeech = createAsyncThunk(
  "soundSlice/fetchTextToSpeech",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.convertTextToSpeech, {
        params: params,
        responseType: "blob",
      });

      dispatch(
        actions.setLoadingState({
          resource: "create_tts",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "create_tts",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const uploadTTS = createAsyncThunk(
  "soundSlice/uploadTTS",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(API_ENDPOINTS.uploadTTS, params);
      dispatch(
        actions.setLoadingState({
          resource: "create_tts",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "create_tts",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const postUploadedUserSound = createAsyncThunk(
  "soundSlice/uploadSound",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(API_ENDPOINTS.getTtsSounds, params);
      dispatch(
        actions.setLoadingState({
          resource: "upload_sound",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "upload_sound",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const uploadSound = createAsyncThunk(
  "soundSlice/uploadSound",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(API_ENDPOINTS.uploadSound, params);
      dispatch(
        actions.setLoadingState({
          resource: "upload_sound",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "upload_sound",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const multiSoundUpload = createAsyncThunk(
  "soundSlice/multiSoundUpload",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(API_ENDPOINTS.multiSoundUpload, params);
      dispatch(
        actions.setLoadingState({
          resource: "upload_sound",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "upload_sound",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error });
    }
  }
);

export const deleteSound = createAsyncThunk(
  "soundSlice/deleteSound",
  async (soundId, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${API_ENDPOINTS.deleteSound}${soundId}/`
      );
      dispatch(
        actions.setLoadingState({
          resource: "sound_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "sound_lists",
          loading_state: "loaded",
        })
      );
      let errorMessage = error?.response?.data;

      if (errorMessage?.error_message) {
        errorMessage = errorMessage["error_message"];
      }
      return rejectWithValue({ error: errorMessage });
    }
  }
);

export const soundsSlice = createSlice({
  name: "soundsSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });

    builder.addCase(fetchTTSSoundsLists.pending, (state) => {
      state.soundList = [];
    });
    builder.addCase(fetchTTSSoundsLists.fulfilled, (state, { payload }) => {
      if (payload?.data) {
        const { data } = payload;
        const { meta, objects } = data;
        state.soundList = objects;
        state.soundListMetaData = meta;
      }
    });
    builder.addCase(fetchTTSSoundsLists.rejected, (state, action) => {});
  },

  reducers: {
    setManageSoundsTabIndex: (state, action) => {
      state.activeSoundTab = action.payload;
    },

    resetSoundsList: (state, action) => {
      state.soundList = [];
    },

    setSelectedSounds: (state, action) => {
      state.selectedSounds = [...action.payload];
    },

    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },

    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },

    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    setSoundListingApiPayload: (state, action) => {
      state.soundListingsPayload = action.payload;
    },
 
  },
});

export const {
  setManageSoundsTabIndex,
  setSelectedSounds,
  resetSoundsList,
  setSearchQuery,
  setPageSize,
  setCurrentPage,
  setSoundListingApiPayload
} = soundsSlice.actions;
export default soundsSlice.reducer;
